import React, { useEffect } from 'react';
import {
  BoldItalicUnderlineToggles,
  MDXEditor,
  UndoRedo,
  linkDialogPlugin,
  linkPlugin,
  CreateLink,
  toolbarPlugin,
  MDXEditorMethods,
} from '@mdxeditor/editor';
import '@mdxeditor/editor/style.css';
import { Box, FormHelperText } from '@mui/material';
import { useStyles } from './style';
import clsx from 'clsx';
const EditorComponent = ({ editable, value, onChange, error}) => {
  const style = useStyles();
  const mdxEditorRef = React.useRef<MDXEditorMethods>(null)
  useEffect(()=>{
    mdxEditorRef.current?.setMarkdown(value)
  },[value])
  return (
    <>
       
    <Box className={clsx(style.root, error && style.error)}     >
      <MDXEditor
        readOnly={!editable}
        ref={mdxEditorRef}
        markdown={''}
        onChange={onChange}
        plugins={[
          linkPlugin(), // Link plugin enabled
          linkDialogPlugin(),
          toolbarPlugin({
            toolbarContents: () => (
              <Box className={style.toolbarWrap} >
                <UndoRedo />
                <BoldItalicUnderlineToggles />
                <CreateLink />
              </Box>
            ),
          }),
        ]}
      />
    </Box>
    <FormHelperText sx={{fontWeight: 500}} error > {error} &nbsp;</FormHelperText>
    </>
  );
};

export default EditorComponent;
